import { takeEvery } from 'redux-saga/effects';
import * as TimesheetEntriesTypes from './TimesheetEntries/actionDefinitions';
import {
  createTimesheetEntryRequestSaga,
  deleteTimesheetEntryRequestSaga,
  getTimesheetEntriesRequestSaga,
  updateTimesheetEntryRequestSaga,
} from './TimesheetEntries/sagas';
import { createTimesheetRowRequestSaga, getTimesheetRowRequestSaga, getTimesheetRowsRequestSaga } from './TimesheetRows/sagas';
import * as TimesheetRowsTypes from './TimesheetRows/types';
import { updateAccessToken } from './User/sagas';
import { setAccessToken } from './authentication-slice';

export function* watchSagas() {
  yield takeEvery(TimesheetEntriesTypes.CREATE_TIMESHEET_ENTRY_REQUEST, createTimesheetEntryRequestSaga);
  yield takeEvery(TimesheetEntriesTypes.DELETE_TIMESHEET_ENTRY_REQUEST, deleteTimesheetEntryRequestSaga);
  yield takeEvery(TimesheetEntriesTypes.GET_TIMESHEET_ENTRIES_REQUEST, getTimesheetEntriesRequestSaga);
  yield takeEvery(TimesheetEntriesTypes.UPDATE_TIMESHEET_ENTRY_REQUEST, updateTimesheetEntryRequestSaga);

  yield takeEvery(TimesheetRowsTypes.CREATE_TIMESHEET_ROW_REQUEST, createTimesheetRowRequestSaga);
  yield takeEvery(TimesheetRowsTypes.GET_TIMESHEET_ROW_REQUEST, getTimesheetRowRequestSaga);
  yield takeEvery(TimesheetRowsTypes.GET_TIMESHEET_ROWS_REQUEST, getTimesheetRowsRequestSaga);

  yield takeEvery(setAccessToken.type, updateAccessToken);
}
